'use client';

import dynamic from 'next/dynamic';
import React from 'react';
import { isAuthorizedToInteractWithDevelopmentTools } from '@mentimeter/user';
import { flags as confidenceFlags } from '@mentimeter/flags/confidence/experiments';

interface DevelopmentToolsSetupProps {
  children: React.ReactNode;
}

const DevelopmentToolsImplementation = dynamic(
  () =>
    import('@mentimeter/development-tools/setup').then(
      (mod) => mod.DevelopmentToolsSetup,
    ),
  {
    ssr: false,
  },
);

export const DevelopmentToolsSetup: React.FC<DevelopmentToolsSetupProps> = ({
  children,
}) => {
  return (
    <DevelopmentToolsImplementation
      confidenceExperiments={confidenceFlags}
      isAuthorizedToInteractWithDevelopmentTools={isAuthorizedToInteractWithDevelopmentTools()}
    >
      {children}
    </DevelopmentToolsImplementation>
  );
};
